import { Component } from '@angular/core';
@Component({
  selector: 'app-error',
  templateUrl: './app.error.component.html',
  styleUrls: ['./app.error.component.scss']
})
export class AppErrorComponent {
  constructor() {

  }
  async redirectToLogin() {
    window.location.href = '/login';
  }
}
